import { AxiosError } from "axios";

import { api } from "@/lib/axios";

type Platform = {
	platform_id: string;
	link: string;
	external_id: string;
};

export interface updateAdminProductsParams {
	name: string;
	image: File | string;
	type_id: string;
	niche_id: string;
	telegram_link: string;
	platforms: Platform[];
}

export async function updateAdminProducts(
	data: FormData,
	id: string,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.post(`/product/update/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
